import React from 'react';
import { graphql, HeadProps, PageProps } from 'gatsby';
import { getSrc } from 'gatsby-plugin-image';
import PostPage from 'containers/PostPage';
import { PostPageContext } from 'containers/PostPage/models';
import SEO from 'components/SEO';
import StructuredPostData from './StructuredPostData';

const PostTemplate = (props: PageProps<Queries.PostPageQuery, PostPageContext>) => {
  return <PostPage {...props} />;
};

export default PostTemplate;

export const Head = ({ data }: HeadProps<Queries.PostPageQuery, PostPageContext>) => {
  const thumbnail = data.markdownRemark?.frontmatter?.thumbnail?.childImageSharp;
  const thumbnailUrl = thumbnail != null ? getSrc(thumbnail) : undefined;

  return (
    <>
      <SEO
        title={data.markdownRemark?.frontmatter?.title ?? undefined}
        description={data.markdownRemark?.excerpt ?? undefined}
        image={thumbnailUrl}
      />
      {data.markdownRemark && <StructuredPostData post={data.markdownRemark} />}
    </>
  );
};

export const pageQuery = graphql`
  query PostPage($slug: String!, $lang: String!, $postGroup: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      ...Post
    }
    allMarkdownRemark(filter: { fields: { postGroup: { eq: $postGroup }, lang: { ne: $lang } } }) {
      edges {
        node {
          ...Post
        }
      }
    }
  }
`;
